import { useState } from "react";
import { FileText, Mail, Phone, Upload, ScrollText, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { uploadFile, fileUrl } from "@/lib/upload";

export const RulesFields = ({ value, onChange }) => {
  const [prog, setProg] = useState(null);
  const [progP, setProgP] = useState(null);
  const set = (k, v) => onChange({ ...value, [k]: v });
  const pickPdf = (field, kind, label, setP) => async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.type !== "application/pdf") return toast.error("Carica un file PDF");
    if (f.size > 20 * 1024 * 1024) return toast.error("PDF troppo grande (max 20 MB)");
    setP(0);
    try {
      const doc = await uploadFile(f, kind, setP);
      set(field, doc.id);
      toast.success(`${label} PDF caricato`);
    } catch (err) { toast.error(err.message || "Caricamento non riuscito"); } finally { setP(null); }
  };
  const pick = pickPdf("rules_file_id", "rules_pdf", "Regolamento", setProg);
  const pickPrivacy = pickPdf("privacy_file_id", "privacy_pdf", "Informativa privacy", setProgP);
  return (
    <div className="space-y-3" data-testid="rules-fields">
      <div className="space-y-1.5">
        <Label className="flex items-center gap-1.5"><ScrollText className="h-3.5 w-3.5" /> Regolamento (testo)</Label>
        <Textarea data-testid="rules-text-input" rows={5} value={value.rules_text || ""} onChange={(e) => set("rules_text", e.target.value)} placeholder="Testo del regolamento del concorso (facoltativo se carichi il PDF)" />
      </div>
      <div className="rounded-lg bg-secondary/40 p-3 space-y-2" data-testid="rules-pdf-box">
        <Label className="flex items-center gap-1.5 text-xs"><FileText className="h-3.5 w-3.5" /> Regolamento PDF</Label>
        {value.rules_file_id && <a href={fileUrl(value.rules_file_id)} target="_blank" rel="noreferrer" className="text-xs text-primary underline" data-testid="rules-pdf-link">Apri PDF caricato</a>}
        <div className="flex items-center gap-2">
          <label className="flex-1 cursor-pointer">
            <input type="file" accept="application/pdf,.pdf" onChange={pick} className="hidden" data-testid="rules-pdf-input" />
            <div className="h-9 rounded-md border border-dashed border-border grid place-items-center text-xs text-muted-foreground hover:border-primary">
              {prog !== null ? `Caricamento ${prog}%` : <span className="flex items-center gap-1"><Upload className="h-3.5 w-3.5" /> {value.rules_file_id ? "Sostituisci PDF" : "Carica PDF"}</span>}
            </div>
          </label>
          {value.rules_file_id && <Button size="sm" variant="ghost" onClick={() => set("rules_file_id", null)} data-testid="rules-pdf-remove">Rimuovi</Button>}
        </div>
      </div>
      <div className="space-y-1.5 pt-2 border-t border-border">
        <Label className="flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5" /> Informativa privacy (testo)</Label>
        <Textarea data-testid="privacy-text-input" rows={5} value={value.privacy_text || ""} onChange={(e) => set("privacy_text", e.target.value)} placeholder="Testo dell'informativa privacy del concorso (facoltativo se carichi il PDF)" />
      </div>
      <div className="rounded-lg bg-secondary/40 p-3 space-y-2" data-testid="privacy-pdf-box">
        <Label className="flex items-center gap-1.5 text-xs"><FileText className="h-3.5 w-3.5" /> Informativa privacy PDF</Label>
        {value.privacy_file_id && <a href={fileUrl(value.privacy_file_id)} target="_blank" rel="noreferrer" className="text-xs text-primary underline" data-testid="privacy-pdf-link">Apri PDF caricato</a>}
        <div className="flex items-center gap-2">
          <label className="flex-1 cursor-pointer">
            <input type="file" accept="application/pdf,.pdf" onChange={pickPrivacy} className="hidden" data-testid="privacy-pdf-input" />
            <div className="h-9 rounded-md border border-dashed border-border grid place-items-center text-xs text-muted-foreground hover:border-primary">
              {progP !== null ? `Caricamento ${progP}%` : <span className="flex items-center gap-1"><Upload className="h-3.5 w-3.5" /> {value.privacy_file_id ? "Sostituisci PDF" : "Carica PDF"}</span>}
            </div>
          </label>
          {value.privacy_file_id && <Button size="sm" variant="ghost" onClick={() => set("privacy_file_id", null)} data-testid="privacy-pdf-remove">Rimuovi</Button>}
        </div>
        <p className="text-[11px] text-muted-foreground">Pubblicata su /privacy/&lt;concorso&gt;, linkata da totem, landing e ricevute (QR "PRIVACY").</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div className="space-y-1.5"><Label className="flex items-center gap-1.5"><Mail className="h-3.5 w-3.5" /> Email di contatto</Label><Input data-testid="contact-email-input" type="email" value={value.contact_email || ""} onChange={(e) => set("contact_email", e.target.value)} placeholder="info@azienda.it" /></div>
        <div className="space-y-1.5"><Label className="flex items-center gap-1.5"><Phone className="h-3.5 w-3.5" /> Telefono di contatto</Label><Input data-testid="contact-phone-input" type="tel" value={value.contact_phone || ""} onChange={(e) => set("contact_phone", e.target.value)} placeholder="+39 02 1234567" /></div>
      </div>
    </div>
  );
};
